import PropTypes from 'prop-types';
import get from 'lodash/get';
import groupBy from 'lodash/groupBy';
import take from 'lodash/take';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import MessageListItem from './MessageListItem';

const getOtherUserId = user => message => (
  message.user_from.id === user.id
  ? message.user_to.id
  : message.user_from.id
);

const ListMessageThreads = props => {
  const {messages, user} = props;
  const messagesByOtherUserId = groupBy(
    (messages || []).map(m => ({
      ...m,
      other_user_id: getOtherUserId(user)(m),
    })),
    m => get(m, 'other_user_id')
  );
  const messageThreads = Object.keys(messagesByOtherUserId)
    .reduce((acc, next) => [...acc, messagesByOtherUserId[next]], [])
    .sort((next, prior) =>
      new Date(prior[0].date_sent) - new Date(next[0].date_sent)
    );
  return (
    <>
      {
        props.messages && props.messages.length
        ? null
        : <Box
          style={{
            minHeight: '6em',
            paddingTop: '2em'
          }}>
            <Typography
              variant='h2'
              align='center'
              style={{color: config().colors.muted}}
            >
              🎉 Your inbox is empty!
            </Typography>
          </Box>
      }
      {messageThreads.map(messages =>
          // show last message from each user
          take(messages || [], 1)
            .map(m =>
              <MessageListItem
                message={m}
                user={user}
                displayUser={m.user_from.id === user.id ? m.user_to : m.user_from}
                count={(messages || [])
                  .filter(m => !m.is_read && m.user_to.id === user.id)
                  .length
                }
              />
            )
        )}
    </>
  );
};

ListMessageThreads.propTypes = {
  user: PropTypes.object,
  messages: PropTypes.arrayOf(PropTypes.object),
};

export default ListMessageThreads;
